import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

/** 開いた状態を示す Tailwind クラス（grid-template-rows: 1fr） */
const OPEN_CLASS = 'tw:grid-rows-[1fr]';

/**
 * @element kd-footer-accordion
 * @description SP フッターメニューのアコーディオン開閉を制御する。
 * grid-template-rows トランジションでスムーズにアニメーションする。
 */
@customElement('kd-footer-accordion')
export class KdFooterAccordion extends LitElement {
  createRenderRoot() {
    return this;
  }

  /** クリックハンドラの参照（解除用） */
  private handlers: { trigger: HTMLElement; handler: (e: Event) => void }[] = [];

  render() {
    return nothing;
  }

  connectedCallback(): void {
    super.connectedCallback();

    const triggers = this.querySelectorAll<HTMLElement>(
      SELECTORS.FOOTER.ACCORDION_TRIGGER,
    );

    triggers.forEach((trigger) => {
      const handler = (e: Event) => {
        e.preventDefault();
        const parent = trigger.closest('[data-footer-accordion]');
        if (!parent) return;

        const content = parent.querySelector<HTMLElement>(
          SELECTORS.FOOTER.ACCORDION_CONTENT,
        );
        const iconPlus = parent.querySelector<HTMLElement>(
          SELECTORS.FOOTER.ACCORDION_ICON_PLUS,
        );
        const iconMinus = parent.querySelector<HTMLElement>(
          SELECTORS.FOOTER.ACCORDION_ICON_MINUS,
        );

        if (!content) return;

        const isOpen = content.classList.contains(OPEN_CLASS);

        // grid-rows クラストグルでアニメーション開閉
        content.classList.toggle(OPEN_CLASS);

        // アイコン切り替え
        if (iconPlus) iconPlus.hidden = !isOpen;
        if (iconMinus) iconMinus.hidden = isOpen;

        // aria-expanded 更新
        trigger.setAttribute('aria-expanded', String(!isOpen));
      };

      trigger.addEventListener('click', handler);
      this.handlers.push({ trigger, handler });
    });
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    for (const { trigger, handler } of this.handlers) {
      trigger.removeEventListener('click', handler);
    }
    this.handlers = [];
  }
}
